import { BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type ContentDashboardActionButtonProps = {
  onClick: () => void;
  label?: string;
};

export function ContentDashboardActionButton({ onClick, label }: ContentDashboardActionButtonProps) {
  const { t } = useTranslation();
  const aria = label ?? t('contentDashboard.open', 'Tableau de bord');

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
      title={aria}
      aria-label={aria}
    >
      <BarChart3 className="h-4 w-4" aria-hidden />
    </button>
  );
}
